import React from "react";
import { Link } from "react-router-dom";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { getPrincipalMessage } from "../Service/Api";
import LazyLoad from "react-lazyload";
import { useState, useEffect } from "react";
function PrincipalMessage() {
  useEffect(() => {
    document.title = "Principal Message -  Gayatri International School";
  }, []);
  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const msgdata = await getPrincipalMessage();
        const data = msgdata.filter(
          (item) => item.school === "NEKPUR" && item.category === "Principal",
        );

        setData(data);
      } catch (error) {
        console.error("Error fetching online registration data:", error);
      }
    };
    fetchData();
  }, []);
  return (
    <>
      <Header />
      <section className="page-header-fb innerslide">
        <div className="innerslide">
          <LazyLoad>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/innerslide1.gif"
              className="img-fluid"
            />
          </LazyLoad>{" "}
        </div>
        <div className="page-header__inner">
          <h2>Principal's Message </h2>
          <ul className="thm-breadcrumb list-unstyled ml-0">
            <li>
              <Link to="/HomeFr"> Home</Link>
            </li>
            <li>|</li>
            <li> Principal's Message </li>
          </ul>
        </div>
      </section>
      <section className="innerbody">
        <div className="container">
          <div className="row">
            {data.length > 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${data[0].attachments}`}
                    className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg"
                    alt={data[0].name || "Image"}
                  />
                </LazyLoad>
                <p>
                  <div dangerouslySetInnerHTML={{ __html: data[0].message }} />
                </p>
                <p className="name">
                  {data[0].name}
                  <span> {data[0].category} </span>
                </p>
              </div>
            )}

            {data.length === 0 && (
              <div className="clearfix">
                <LazyLoad>
                  {" "}
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GISFNU/public/Images/default.jpg"
                    className="img-fluid col-sm-12 col-md-3 float-md-end mb-3 msgimg"
                    alt=""
                  />
                </LazyLoad>
                <p>
                  Gayatri International School, Farrukhabad is committed to
                  impart quality education with a perspective to change and
                  contribute both nationally and globally. Ultimately the
                  efforts of every education should be to unlock the treasure of
                  kindness and generosity hidden in the soul of a child. Our aim
                  and commitment is to provide each student a platform to become
                  the best human, better citizen and an asset to the country. It
                  has been my proud privileged working with the premier public
                  schools of the country THE SCINDIA SCHOOL, FORT GWALIOR and
                  THE SHERWOOD COLLEGE, NAINITAL a renowned British cultured
                  boarding school that helped me to discover the true meaning of
                  education. “TO SERVE THE HUMAN IS THE NOBLEST WORK". Now as
                  principal I wish to lead this flourishing Gayatri
                  International School with value based support system of our
                  students, committed teachers, compassionate parents and highly
                  acclaimed management. To make learning beneficial we keep our
                  method “child centric” knowing that each child is an
                  individual with different capabilities, abilities and talent
                  hidden within, only we need to explore and unveil those
                  qualities. True learning helps the child to handle the stress,
                  conflict and control emotions that are extremely necessary in
                  today’s fast paced life and demanding world. At the end, I
                  would like to say the journey through the life and learning at
                  GIS, Farrukhabad is to explore the new dimensions of thought
                  process to understand our students better and also our focus
                  is to prepare them a respectable citizenwith leadership
                  quality imbibed with Indian values, culture and ethos.
                </p>

                <p className="name">
                  Mr. M.A. Siddiqui <span> Principal</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default PrincipalMessage;
